import { NavigationProp, useNavigation } from '@react-navigation/native';
import { RootStackParamList } from 'navigation/AppNavigator.web';
import { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { useGetPinQuery, useUpdatePinMutation } from 'services/backend';
import { PIN_LENGTH } from 'utils/constants';
import { calcSizeForDevice } from 'utils/index';
import { Platform } from 'utils/platform';

import { ProfilePinField } from 'components/Profile/Form/PinField';
import { ProfileActionBar } from 'components/Profile/Form/ProfileActionBar';
import { ProfileSectionItem } from 'components/Profile/Form/ProfileSectionItem';
import TvKeyboard from 'components/TvKeyboard';
import { WebDiv } from 'components/WebDiv';
import IsLoading from 'components/isLoading';

type ProfileEditPinScreenProps = {
  onClose: () => void;
};

const ProfileEditPinScreen = ({ onClose }: ProfileEditPinScreenProps) => {
  const navigation = useNavigation<NavigationProp<RootStackParamList>>();
  const [pin, setPin] = useState('');

  const { data: pinData, isLoading: isPinQueryLoading } = useGetPinQuery();
  const [updatePin, { isLoading: isUpdatingPin }] = useUpdatePinMutation();

  const isLoading = isPinQueryLoading || isUpdatingPin;
  const isValidPin = pin?.length === PIN_LENGTH;
  const pinChanged = pin !== pinData?.pin;

  const handleConfirm = async () => {
    if (!pinData?._id || !isValidPin) return;

    if (!pinChanged) {
      onClose();
      return;
    }

    try {
      await updatePin({ id: pinData?._id, pin }).unwrap();
      navigation.goBack();
    } catch (error) {
      console.error('Error updating PIN', error);
    }
  };

  if (isLoading) {
    return (
      <View style={styles.loadingContainer}>
        <IsLoading />
      </View>
    );
  }

  return (
    <View style={[styles.container, Platform.isTV ? styles.tvContainer : styles.webContainer]}>
      <ProfileSectionItem label="Editar PIN da conta">
        <ProfilePinField value={pin} onChange={setPin} />
      </ProfileSectionItem>

      <WebDiv className="navigation-container navigation-priority">
        <View style={styles.keyboardContent}>
          {Platform.isTV && (
            <WebDiv className="navigation-grid">
              <TvKeyboard
                variant="numeric"
                appearance="strong"
                textValue={pin}
                setTextValue={setPin}
              />
            </WebDiv>
          )}
          <View style={styles.actionBarContainer}>
            <ProfileActionBar confirmLabel="Salvar" onConfirm={handleConfirm} onCancel={onClose} />
          </View>
        </View>
      </WebDiv>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'column',
    marginTop: calcSizeForDevice(71),
    alignItems: 'center',
    alignSelf: 'center',
  },
  tvContainer: {
    width: calcSizeForDevice(538),
  },
  webContainer: {
    width: '90%',
    maxWidth: calcSizeForDevice(538),
    alignItems: 'center',
  },
  keyboardContent: {
    flexDirection: 'column',
  },
  actionBarContainer: {
    marginTop: calcSizeForDevice(16),
  },
  loadingContainer: {
    width: '100%',
    height: calcSizeForDevice(560),
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default ProfileEditPinScreen;
